import { z } from 'zod/v4';

import {
  AnyComplexConditionDef,
  ComplexConditionDef,
} from '../../../types/complexConditionDef';
import { PipelineGuardProjectHasTag } from '../../../types/pipelineGuardTypes';
import customFieldConditionDef from './customFieldConditionDef';
import TagExtraPicker from './TagExtraPicker';

type ProjectHasTagExtra = {
  tagPublicId: string;
  tagName: string;
  tagColour: string;
};

const projectHasTagDef: ComplexConditionDef<
  PipelineGuardProjectHasTag,
  ProjectHasTagExtra
> = {
  key: 'PROJECT_HAS_TAG',
  label: (t) =>
    t('pipelineGuards.conditions.PROJECT_HAS_TAG.hasBeen', {
      context: 'blank',
    }),
  inverseLabel: (t) =>
    t('pipelineGuards.conditions.PROJECT_HAS_TAG.hasNotBeen', {
      context: 'blank',
    }),
  extraSchema: z.object({
    tagPublicId: z
      .string({ error: 'A tag must be selected' })
      .min(1, 'A tag must be selected'),
    tagName: z.string(),
    tagColour: z.string(),
  }),
  matches: (child): child is PipelineGuardProjectHasTag =>
    child.type === 'projectHasTag',
  deriveExtra: (child) => ({
    tagPublicId: child.tagPublicId,
    tagName: child.tagName,
    tagColour: child.tagColour ?? '',
  }),
  toChild: (extra, tempIdentifier) => ({
    type: 'projectHasTag',
    tagPublicId: extra.tagPublicId,
    tagName: extra.tagName,
    tagColour: extra.tagColour || null,
    tempIdentifier,
  }),
  ExtraPicker: TagExtraPicker,
};

export const COMPLEX_CONDITIONS: AnyComplexConditionDef[] = [
  projectHasTagDef,
  customFieldConditionDef,
];
